import React from "react";
import { Link, useLocation } from "react-router-dom";
import LandingLayout from "../components/LandingLayout";
import { useRedirectIfLoggedIn } from "../hooks/useRedirectIfLoggedIn";
import ProfilesGrid from "../components/landing/ProfilesGrid";
import FinalCTASection from "../components/landing/FinalCTASection";

const profiles = [
    {
        icon: "💰",
        name: "Inversor / Flipper",
        tagline: "Calcula el ROI de cualquier propiedad antes de comprar",
        description: "Analiza oportunidades de flipping en segundos. Estimación de reforma, costes completos y rentabilidad en múltiples escenarios.",
        problems: ["Las buenas oportunidades desaparecen en 48 horas"],
        url: "/landing/inversor",
        colorClass: "bg-yellow-50",
    },
    {
        icon: "🏠",
        name: "Agente Inmobiliario",
        tagline: "Cierra operaciones que se te caen por la reforma",
        description: "Ofrece a compradores e inversores el coste de reforma en la misma visita. Diferénciate con un servicio que tu competencia no tiene.",
        problems: ["Casas a reformar con precios fuera de mercado se quedan sin vender"],
        url: "/landing/agente-inmobiliario",
        colorClass: "bg-blue-50",
    },
    {
        icon: "🔧",
        name: "Constructor / Reformista",
        tagline: "Haz presupuestos sin oficina técnica",
        description: "Genera presupuestos detallados a partir de fotos con IA. Lo que antes costaba 8 horas, ahora te lleva 1.",
        problems: ["Preparar presupuestos es lento y da mucho trabajo"],
        url: "/landing/constructor",
        colorClass: "bg-green-50",
    },
    {
        icon: "🔍",
        name: "Comprador",
        tagline: "Averigua cuánto te va a costar reformar antes de decidirte",
        description: "Analiza cualquier vivienda: coste de reforma, valor post-reforma y un informe claro para negociar con datos.",
        problems: ["Negociar sin datos es ir a ciegas"],
        url: "/landing/comprador",
        colorClass: "bg-purple-50",
    },
    {
        icon: "🏡",
        name: "Propietario",
        tagline: "Entiende cuánto vale tu casa y cuánto se revaloriza si la reformas",
        description: "Descubre el valor actual de tu vivienda y cuánto podrías ganar reformándola antes de vender o alquilar.",
        problems: ["Reformar la casa puede merecer la pena para revalorizarla"],
        url: "/landing/propietario",
        colorClass: "bg-pink-50",
    },
    {
        icon: "🎨",
        name: "Decorador / Interiorista",
        tagline: "Presupuesta la decoración antes de la primera visita",
        description: "Analiza propiedades con IA, estima el coste de decoración y genera propuestas profesionales. Gana proyectos antes que nadie.",
        problems: ["Los clientes quieren saber el coste total antes de decidirse"],
        url: "/landing/decorador",
        colorClass: "bg-orange-50",
    },
];

const LandingHome = () => {
    useRedirectIfLoggedIn();
    const location = useLocation();
    const loginUrl = `/login?redirect=${encodeURIComponent(location.pathname)}`;

    return (
        <LandingLayout>
            <section className="bg-gradient-to-br from-blue-50 to-blue-100 py-28 text-center">
                <div className="max-w-5xl mx-auto px-6">
                    <p className="text-gray-500 text-lg mb-3">Transformamos oportunidades en valor</p>
                    <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight mb-4">
                        Analiza cualquier propiedad.<br />
                        <span className="text-brand-blue">Decide con datos.</span>
                    </h1>
                    <p className="text-gray-500 text-lg max-w-2xl mx-auto mb-8">
                        Estimamos el coste de reforma, calculamos la rentabilidad y te damos los datos que necesitas para tomar decisiones inmobiliarias con confianza.
                    </p>
                    <Link
                        to={loginUrl}
                        className="inline-block bg-brand-blue text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-800 transition-all hover:-translate-y-0.5 hover:shadow-lg"
                    >
                        Acceder a la plataforma
                    </Link>
                </div>
            </section>

            <ProfilesGrid profiles={profiles} />

            <FinalCTASection
                title="Empieza a analizar propiedades hoy"
                text="Sin compromisos. Introduce una dirección o pega la URL de Idealista y obtén un análisis completo en segundos."
                ctaText="Acceder a Reformista"
            />
        </LandingLayout>
    );
};

export default LandingHome;
